export const jewelleryTierData: { tier: 'Excellent' | 'Good' | 'Special', baseTypes: string[] }[] = [
  {
    tier: "Excellent",
    baseTypes: [
      // Amulets
      "Absent Amulet",
      "Gold Amulet",
      "Tenebrous Amulet",
      "Penumbra Amulet",
      // Rings
      "Gold Ring",
      "Tenebrous Ring",
      "Breach Ring",
      "Penumbra Ring",
      "Refined Breach Ring",
      // Belts
    ],
  },
  {
    tier: "Good",
    baseTypes: [
      // Amulets
      "Solar Amulet",
      "Dusk Amulet",
      "Gloam Amulet",
      // Rings
      "Prismatic Ring",
      "Biostatic Ring",
      "Vitalic Ring",
      "Mnemonic Ring",
      "Kinetic Ring",
      "Oneiric Ring",
      "Grasping Ring",
      "Dusk Ring",
      "Gloam Ring",
      // Belts
      "Utility Belt",
    ],
  },
  {
    tier: "Special",
    baseTypes: [
      // Amulets
      "Pearlescent Amulet",
      "Lament Amulet",
      "Portent Amulet",
      "Corona Amulet",
      "Twisted Amulet",
      "Distorted Amulet",
      // Rings
      // Belts
      "Stalking Belt",
      "Invoking Belt",
      "Sinew Belt",
      "Forking Belt",
    ],
  },
];

export const excellentJewelleryBaseTypes = jewelleryTierData.find(t => t.tier === 'Excellent')!.baseTypes;
export const goodJewelleryBaseTypes = jewelleryTierData.find(t => t.tier === 'Good')!.baseTypes;
export const specialJewelleryBaseTypes = jewelleryTierData.find(t => t.tier === 'Special')!.baseTypes;
